import { Button } from "@/components/ui/button";
import { Shield, Award, Star, ArrowRight, CheckCircle2 } from "lucide-react";

interface EmployerCTAProps {
  onRequestDemo: () => void;
}

const EmployerCTA = ({ onRequestDemo }: EmployerCTAProps) => {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-br from-[#0D1B2A] via-[#1B3A4B] to-[#0D1B2A] relative overflow-hidden">
      {/* Premium background effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#ffdb4d]/10 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#ffdb4d]/5 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2" />
      </div>
      
      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `linear-gradient(rgba(255,219,77,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,219,77,1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight leading-[1.1]">
            Ready to Transform Your
            <span className="block text-[#ffdb4d] mt-2">Team's Health?</span>
          </h2>
          <p className="text-xl md:text-2xl text-white/80 mb-10 max-w-3xl mx-auto leading-relaxed">
            Join forward-thinking companies investing in employee metabolic wellness. 
            See measurable ROI in 90 days.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            <Button 
              onClick={onRequestDemo}
              size="lg" 
              className="bg-[#ffdb4d] text-[#0D1B2A] hover:bg-white font-bold px-10 py-7 text-lg shadow-2xl shadow-[#ffdb4d]/20 group transition-all duration-300"
            >
              Get a Custom Quote
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              onClick={onRequestDemo}
              variant="outline"
              size="lg" 
              className="border-2 border-white/30 text-white hover:bg-white/10 hover:border-white/50 font-semibold px-8 py-7 text-lg backdrop-blur-sm"
            >
              Schedule Executive Briefing
            </Button>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-8 text-white/60 text-sm">
            <div className="flex items-center gap-2 hover:text-white/90 transition-colors">
              <Shield className="w-5 h-5 text-[#ffdb4d]" />
              <span className="font-medium">HIPAA Compliant</span>
            </div>
            <div className="flex items-center gap-2 hover:text-white/90 transition-colors">
              <Award className="w-5 h-5 text-[#ffdb4d]" />
              <span className="font-medium">SOC 2 Certified</span>
            </div>
            <div className="flex items-center gap-2 hover:text-white/90 transition-colors">
              <Star className="w-5 h-5 text-[#ffdb4d]" />
              <span className="font-medium">BBB A+ Rating</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmployerCTA;
